module.exports = __webpack_public_path__ + "static/media/review2.08f47119.webm";